module.exports = __webpack_public_path__ + "img/组 18-5.d24c58d4.png";